import api from "./api.js";

export default class BoardApi {
  // ---------- 게시판 ---------- //
  static async createBoard(data) {
    return await api.post(`api/board-post`, data);
  }

  static async getListBoard(params) {
    return await api.get(`api/board-post`, params);
  }

  static async getByIdBoard(boardId, params) {
    return await api.get(`api/board-post/${boardId}`, params);
  }

  static async updateBoard(boardId, data) {
    return await api.patch(`api/board-post/${boardId}`, data);
  }

  static async deleteBoard(boardId, params) {
    return await api.del(`api/board-post/${boardId}`, params);
  }

  static async updateActivationBoard(boardId, data) {
    return await api.patch(`api/board-post/activation/${boardId}`, data);
  }

  static async updateAnswerBoard(boardId, data) {
    return await api.patch(`api/board-post/answer/status/${boardId}`, data);
  }

  // ---------- 게시판 - 댓글 ---------- //
  static async createBoardComment(data) {
    return await api.post(`api/board-comment`, data);
  }

  static async getListBoardComment(params) {
    return await api.get(`api/board-comment`, params);
  }

  static async getByIdBoardComment(commentId, params) {
    return await api.get(`api/board-comment/${commentId}`, params);
  }

  static async updateBoardComment(commentId, data) {
    return await api.patch(`api/board-comment/${commentId}`, data);
  }

  static async deleteBoardComment(commentId, params) {
    return await api.del(`api/board-comment/${commentId}`, params);
  }

  static async updateActivationBoardComment(commentId, data) {
    return await api.patch(`api/board-comment/activation/${commentId}`, data);
  }

  // ---------- 게시판 - 답글 ---------- //
  static async createBoardReply(data) {
    return await api.post(`api/board-reply`, data);
  }

  static async getListBoardReply(params) {
    return await api.get(`api/board-reply`, params);
  }

  static async getByIdBoardReply(replyId, params) {
    return await api.get(`api/board-reply/${replyId}`, params);
  }

  static async updateBoardReply(replyId, data) {
    return await api.patch(`api/board-reply/${replyId}`, data);
  }

  static async deleteBoardReply(replyId, params) {
    return await api.del(`api/board-reply/${replyId}`, params);
  }

  static async updateActivationBoardReply(replyId, data) {
    return await api.patch(`api/board-reply/activation/${replyId}`, data);
  }

  // ---------- 커뮤니티 - 상위 카테고리 ---------- //
  static async createMain(data) {
    return await api.post(`api/board-category`, data);
  }

  static async getListMain(params) {
    return await api.get(`api/board-category`, params);
  }

  static async getByIdMain(categoryId, params) {
    return await api.get(`api/board-category/${categoryId}`, params);
  }

  static async updateMain(data) {
    return await api.patch(`api/board-category/`, data);
  }

  static async deleteMain(categoryId, params) {
    return await api.del(`api/board-category/${categoryId}`, params);
  }

  // ---------- 커뮤니티 - 하위 카테고리 ---------- //
  static async createSub(data) {
    return await api.post(`api/board-sub-category`, data);
  }

  static async getListSub(params) {
    return await api.get(`api/board-sub-category`, params);
  }

  static async getByIdSub(categoryId, params) {
    return await api.get(`api/board-sub-category/${categoryId}`, params);
  }

  static async updateSub(data) {
    return await api.patch(`api/board-sub-category/`, data);
  }

  static async deleteSub(categoryId, params) {
    return await api.del(`api/board-sub-category/${categoryId}`, params);
  }
}
